import React, {useState, useEffect, useRef} from 'react';
import './ComponentCss/CompanyCardList.css';
import axios from "axios";
import config from "../ip.json";
import deleteRecord from "../Image/delete.png";
import Swal from "sweetalert2";
import {toCommaedNumber} from "../DataBind/common";


const CompanyCardListinRoomNumber = ({
                                         total_amount,
                                         id,
                                         years,
                                         rental,
                                         surtax,
                                         electricityBill,
                                         gasBill,
                                         isRental,
                                         isSurtax,
                                         isElectricityBill,
                                         isGasBill,
                                         room_number,
                                         deleteRecordFunction
                                     }) => {
    const [modalVisible, setModalVisible] = useState(false); // 모달 상태
    const [modalPosition, setModalPosition] = useState({x: 0, y: 0}); // 모달 위치 상태
    const [activeButton, setActiveButton] = useState(null); // 클릭한 버튼 저장
    const [selectedDate, setSelectedDate] = useState(''); // 선택된 날짜 상태
    const [missedPayments, setMissedPayments] = useState({}); // 각 버튼의 미납처리 상태 저장
    const [errorMessage, setErrorMessage] = useState('');
    const isFirstRender = useRef(true);


    const [data, setData] = useState(
        {
            total_amount:total_amount,
            id: id,
            year: years.split('T')[0].split('-')[0],
            month: years.split('T')[0].split('-')[1],
            rental: rental,
            surtax: surtax,
            electricityBill: electricityBill,
            gasBill: gasBill,
            isRental: String(isRental).split('T')[0],
            isSurtax: String(isSurtax).split('T')[0],
            isElectricityBill: String(isElectricityBill).split('T')[0],
            isGasBill: String(isGasBill).split('T')[0],

        }
    )
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleDeleteClick = () => {
        setIsModalOpen(true); // 모달창 열기
    };

    const handleCloseModal = () => {
        setIsModalOpen(false); // 모달창 닫기
    };
    const 삭제 = () => {
        Swal.fire({
            title: "삭제 완료!",
            icon: "success"
        });
    };
    const 실패 = () => {
        Swal.fire({
            title: "삭제 실패",
            icon: "error"
        });
    };

    const handleConfirmDelete = async () => {


        const jwtToken = sessionStorage.getItem("Authorization");
        let room = data.year+"-"+data.month+"-01"
        let number = String(room_number)
        console.log(room)

        try {
            const response = await axios.post(
                config.url + "/v2/payment/delete",
                {
                    idx: id,
                    date: room,
                    room: room_number,
                },
                {
                    headers: {
                        Authorization: jwtToken,
                        "Content-Type": "application/json",
                    },
                    withCredentials: true,
                }
            );

            console.log("Response:", response.data);
            삭제();

        } catch (error) {
            console.error("Error fetching data:", error);
            실패();
        }


        setIsModalOpen(false); // 모달창 닫기
        deleteRecordFunction()

    };

    useEffect(() => {
        setMissedPayments({
            1: data.isRental === 'null' ? true : false,
            2: data.isSurtax === 'null' ? true : false,
            3: data.isElectricityBill === 'null' ? true : false,
            4: data.isGasBill === 'null' ? true : false,
        });
    }, []);


    const openModal = (e) => {
        const buttonRect = e.target.getBoundingClientRect(); // 클릭한 버튼의 위치 가져오기
        setModalPosition({
            x: buttonRect.right + 10, // 버튼의 오른쪽 옆에 모달 위치 설정
            y: buttonRect.top // 버튼의 상단 위치 기준
        });
        setActiveButton(e.target); // 클릭한 버튼 저장

        setModalVisible(true); // 모달 표시
    };

    // 모달 닫기
    const closeModal = () => {
        setModalVisible(false); // 모달을 닫음
    };

    // 날짜 변경 처리
    const handleDateChange = (e) => {
        setSelectedDate(e.target.value); // 날짜 상태 업데이트
    };

    // 날짜 선택 후 버튼 텍스트 업데이트
    const handleDateSelect = () => {
        if (!selectedDate) {
            // 날짜를 선택하지 않았을 때 경고 메시지 표시
            setErrorMessage('날짜를 설정해주세요.');
        } else {
            if (activeButton) {
                const buttonId = activeButton.dataset.id; // 각 버튼의 ID 가져오기
                let fieldName; // 재할당 가능한 변수 선언

                switch (buttonId) {
                    case '1': // `dataset.id`는 문자열로 반환되므로 '1'로 비교
                        fieldName = 'isRental';
                        break;
                    case '2':
                        fieldName = 'isSurtax';
                        break;
                    case '3':
                        fieldName = 'isElectricityBill';
                        break;
                    case '4':
                        fieldName = 'isGasBill';
                        break;
                    default:
                        fieldName = null;
                        console.error('알 수 없는 버튼 ID:', buttonId);
                        break;
                }


                // 상태를 업데이트하여 React가 렌더링을 처리하도록 설정
                setMissedPayments((prevState) => ({
                    ...prevState,
                    [buttonId]: false, // 미납처리 상태 해제
                }));


                // 새로운 날짜를 상태로 업데이트
                setData((prevData) => ({
                    ...prevData,
                    [fieldName]: selectedDate, // 해당 버튼의 텍스트를 상태로 업데이트
                }));

            }
            closeModal(); // 모달 닫기
            setErrorMessage(''); // 에러 메시지 초기화
        }

    };

    const update = async () => {
        const jwtToken = sessionStorage.getItem("Authorization");

        try {
            const response = await axios.post(config.url + "/v2/payment/company/pay_update",
                {
                    id: Number(data.id),
                    resRent: data.isRental === 'null' || data.isRental === '미납처리' ? null : String(data.isRental),
                    resSurtax: data.isSurtax === 'null' || data.isSurtax === '미납처리' ? null : String(data.isSurtax),
                    resElec: data.isElectricityBill === 'null' || data.isElectricityBill === '미납처리' ? null : String(data.isElectricityBill),
                    resGas: data.isGasBill === 'null' || data.isGasBill === '미납처리' ? null : String(data.isGasBill),
                },
                {
                    headers: {
                        Authorization: jwtToken,

                        "Content-Type": "application/json",
                    },
                    withCredentials: true, // 쿠키 필요 시 설정
                });

            console.log(response.data); // 콘솔로 데이터 확인
        } catch (error) {
            console.error("Error fetching data:", error);
            alert("데이터를 가져오는 중 문제가 발생했습니다.");
        }

    }


    useEffect(() => {

        if (isFirstRender.current) {
            // 첫 렌더링에서는 실행하지 않음
            isFirstRender.current = false;
            return;
        }


        update()


        // 두 번째 렌더링 이후에만 실행
        console.log(
            data.id +
            data.isRental + ' ' +
            data.isSurtax + ' ' +
            data.isElectricityBill + ' ' +
            data.isGasBill
        );
    }, [data.isSurtax, data.isRental, data.isGasBill, data.isElectricityBill]);


    // 미납처리 버튼 클릭 시 처리
    const handleMissedPayment = () => {

        if (activeButton) {
            const buttonId = activeButton.dataset.id; // 각 버튼의 ID 가져오기
            let fieldName; // 재할당 가능한 변수 선언

            switch (buttonId) {
                case '1': // `dataset.id`는 문자열로 반환되므로 '1'로 비교
                    fieldName = 'isRental';
                    break;
                case '2':
                    fieldName = 'isSurtax';
                    break;
                case '3':
                    fieldName = 'isElectricityBill';
                    break;
                case '4':
                    fieldName = 'isGasBill';
                    break;
                default:
                    fieldName = null;
                    console.error('알 수 없는 버튼 ID:', buttonId);
                    break;
            }


            // 상태를 업데이트하여 React가 렌더링을 처리하도록 설정
            setMissedPayments((prevState) => ({
                ...prevState,
                [buttonId]: true, // 미납처리 상태 해제
            }));


            // 새로운 날짜를 상태로 업데이트
            setData((prevData) => ({
                ...prevData,
                [fieldName]: "미납처리", // 해당 버튼의 텍스트를 상태로 업데이트
            }));


            closeModal(); // 모달 닫기
            setErrorMessage(''); // 에러 메시지 초기화
        }


    };

    // 모달 외부 클릭 시 모달 닫기 (이벤트 리스너 추가)
    useEffect(() => {
        const handleClickOutside = (e) => {
            // 모달 외부를 클릭했을 때 모달을 닫음
            if (activeButton && !activeButton.contains(e.target) && !e.target.closest('.modal')) {
                closeModal();
            }
        };

        // 이벤트 리스너 등록
        document.addEventListener('click', handleClickOutside);

        // 컴포넌트 언마운트 시 이벤트 리스너 제거
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [activeButton]); // activeButton이 변경될 때마다 효과를 실행

    return (
        <div className={'list-box'}>
            <div className={'list-element'}>
                <div className={'top'}>{data.year}년 {data.month}월</div>
                <div className={'bottom'} style={{fontWeight: "bold", fontSize: 16, color: "#212121"}}>
                    {room_number}호
                </div>
            </div>


            <div className="list-element">
                <div className="top">{toCommaedNumber(rental)}</div>
                <div className="bottom">
                    <div
                        className="isPayed_1"
                        data-id="1"
                        onClick={openModal}
                        style={{
                            backgroundColor: missedPayments[1] ? '#FEF0EF' : ''

                        }}
                    >
                        {missedPayments[1] ? '미납처리' : data.isRental}

                    </div>
                </div>
            </div>

            <div className="list-element">
                <div className="top">{toCommaedNumber(surtax)}</div>
                <div className="bottom">
                    <div
                        className="isPayed_2"
                        data-id="2"
                        onClick={openModal}
                        style={{
                            backgroundColor: missedPayments[2] ? '#FEF0EF' : ''
                        }}
                    >
                        {missedPayments[2] ? '미납처리' : data.isSurtax}
                    </div>
                </div>
            </div>

            <div className="list-element">
                <div className="top">{toCommaedNumber(electricityBill)}</div>
                <div className="bottom">
                    <div
                        className="isPayed_3"
                        data-id="3"
                        onClick={openModal}
                        style={{
                            backgroundColor: missedPayments[3] ? '#FEF0EF' : ''
                        }}
                    >
                        {missedPayments[3] ? '미납처리' : data.isElectricityBill}
                    </div>
                </div>
            </div>

            <div className="list-element">
                <div className="top">{toCommaedNumber(gasBill)}</div>
                <div className="bottom">
                    <div
                        className="isPayed_4"
                        data-id="4"
                        onClick={openModal}
                        style={{
                            backgroundColor: missedPayments[4] ? '#FEF0EF' : ''
                        }}
                    >
                        {missedPayments[4] ? '미납처리' : data.isGasBill}
                    </div>
                </div>
            </div>


            <div className={'list-element'}>
                <div className={'last-top'}>{toCommaedNumber(total_amount)}원</div>
                <div className={'bottom'}></div>
            </div>

            <div>
                <div
                    className="deleteRecord-list-element"
                    onClick={handleDeleteClick}
                >
                    <img
                        className="deleteRecord-company-btn"
                        src={deleteRecord}
                        alt="See more"
                    />
                </div>

                {isModalOpen && (
                    <div className="modal_delete">
                        <div className="modal-content_delete">
                            <p></p>
                            <div>{data.year}년 {data.month}월 {room_number}호 의 정보를 삭제 하시겠습니까?</div>
                            <p> </p>
                            <button onClick={handleConfirmDelete}>예</button>
                            <button onClick={handleCloseModal}>아니오</button>
                        </div>
                    </div>
                )}
            </div>

            {/* 모달 */}
            {modalVisible && (
                <div className="modal" style={{left: modalPosition.x - 300, top: modalPosition.y - 50}}>
                    <div className="modal-content">
                        <div>
                            <label htmlFor="date-picker">날짜 선택:</label>
                            <input
                                id="date-picker"
                                type="date"
                                value={selectedDate}
                                onChange={handleDateChange}
                            />
                        </div>

                        {/* 날짜가 설정되지 않았을 때 에러 메시지 */}
                        {errorMessage && <div style={{color: 'red', marginTop: '10px'}}>{errorMessage}</div>}

                        <div>
                            <p>선택된 날짜: {selectedDate}</p>
                        </div>

                        <button onClick={handleDateSelect} className={'firstButton'}>납입완료</button>
                        <button onClick={handleMissedPayment} className={'middleButton'}>미납처리</button>
                        <button onClick={closeModal}>닫기</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CompanyCardListinRoomNumber;
